{
  "cta": {
    "create-a-chart": "Crear una tabla"
  },
  "breadcrumb": {
    "dashboard": "Panel",
    "products": "Productos",
    "charts": "Tablas",
    "restock-alerts": "Alertas de reabastecimiento",
    "settings": "Configuración",
    "setting": "Configuración",
    "account": "Cuenta",
    "personal": "Personal",
    "organization": "Organización",
    "appearance": "Apariencia",
    "themes": "Temas",
    "button": "Botón",
    "font-family": "Familia de fuente",
    "uploads": "Archivos subidos",
    "dimensions": "Dimensiones",
    "notifications": "Notificaciones",
    "analytic": "Analítica",
    "analytics": "Analítica",
    "restock-settings": "Configuración de reabastecimiento",
    "inventory": "Alertas de reabastecimiento",
    "plans": "Planes",
    "billing": "Facturación",
    "overview": "Resumen",
    "plan-and-usage": "Plan y uso",
    "chart-views": "Vistas de tabla",
    "add-to-cart": "Añadir al carrito",
    "buy-now": "Comprar ahora",
    "size-recommendations": "Recomendaciones de talla",
    "stock-notifications": "Notificaciones de stock",
    "reports": "Informes",
    "comparison": "Comparación",
    "images": "Archivos subidos",
    "sidekick": "Sidekick",
    "import": "Importación",
    "contact": "Contacto",
    "help-articles": "Artículos de ayuda",
    "new": "Nuevo"
  },
  "page": {
    "dashboard": {
      "table-style-chart": "Tabla de estilo cuadrícula",
      "build-a-fully-custom-grid-with-complete-control-over-every-row-column-and-measurement-unit-best-for-complex-sizing-across-multiple-regions": "Crea una cuadrícula totalmente personalizada con control total sobre cada fila, columna y unidad de medida. Ideal para tallajes complejos en varias regiones.",
      "create-table-chart": "Crear tabla de cuadrícula",
      "create-from-product": "Crear desde producto",
      "start-from-template": "Empezar desde plantilla",
      "browse-templates": "Explorar plantillas",
      "create-with-drag-drop": "Crear con arrastrar y soltar",
      "creating": "Creando",
      "how-would-you-like-to-build-your-chart": "¿Cómo te gustaría<br /><span class=\"text-primary\">crear tu tabla de tallas?</span>",
      "choose-a-method-below-or-tell-us-what-you-sell-and-we-ll-highlight-the-best-fit": "Elige un método a continuación, o dinos qué vendes y destacaremos la mejor opción.",
      "fastest-setup-2-min": "Configuración más rápida · ~2 min",
      "used-by-1000-merchants": "Usado por más de 1000 comercios",
      "auto-generate-a-matching-size-chart-directly-from-your-existing-shopify-variant-data-no-manual-entry-it-reads-your-product-and-fills-the-table-for-you": "Genera automáticamente una tabla de tallas a partir de los datos de variantes de tu Shopify existente. Sin entrada manual: lee tu producto y completa la tabla por ti",
      "garment-templates-ready-to-use": "Plantillas de prendas listas para usar",
      "pick-from-ready-made-templates-for-tops-bottoms-shoes-belts-bags-and-more-customise-any-field-after-great-for-getting-started-in-under-a-minute": "Elige entre plantillas prediseñadas para partes de arriba, partes de abajo, calzado, cinturones, bolsos y más. Personaliza cualquier campo después: ideal para empezar en menos de un minuto.",
      "drag-drop-no-data-needed-upfront": "Arrastrar y soltar · sin datos previos necesarios",
      "upload-any-product-image-and-annotate-measurements-directly-on-it-with-drag-drop-pins-ideal-for-shoes-bags-accessories-and-equipment": "Sube cualquier imagen de producto y anota las medidas directamente sobre ella con pines de arrastrar y soltar. Ideal para calzado, bolsos, accesorios y equipamiento.",
      "excel-like": "Tipo Excel",
      "auto-generated": "Autogenerado",
      "annotate-on-image": "Anotar sobre imagen",
      "what-are-you-selling": "¿Qué vendes?",
      "category-clothing-apparel": "Ropa y prendas de vestir",
      "category-shoes": "Calzado",
      "category-accessories": "Accesorios",
      "category-other": "Otra cosa",
      "start-date": "Fecha de inicio",
      "end-date": "Fecha de fin"
    },
    "products": {
      "select-a-product-to-create-or-link-a-size-chart-for-that-product": "Selecciona un producto para crear o vincular una tabla de tallas para ese producto.",
      "product-name": "Nombre del producto",
      "best-selling": "Más vendidos",
      "most-selling": "Más vendidos primero",
      "least-selling": "Menos vendidos",
      "best-selling-unavailable": "Los datos de ventas aún no están disponibles, así que los productos se muestran por última actualización.",
      "chart-attached": "Tabla adjunta",
      "shopify-status": "Estado en Shopify",
      "search-placeholder": "Buscar en todos los productos...",
      "vendors": "Proveedores",
      "tags": "Etiquetas",
      "statuses": "Estados",
      "collections": "Colecciones",
      "types": "Tipos",
      "add-filter": "Añadir filtro",
      "categories": "Categorías",
      "search-and-filter-tooltip": "Buscar y filtrar (F)",
      "import-selection": "Importar selección",
      "failed-import-measurements": "No se pudieron importar las medidas",
      "product-updated": "Producto actualizado correctamente"
    },
    "charts": {
      "create-edit-duplicate-or-link-a-chart-to-a-product-from-here": "Crea, edita, duplica o vincula una tabla a un producto desde aquí.",
      "chart-name": "Nombre de la tabla",
      "chart-type": "Tipo de tabla",
      "linked-to": "Vinculado a",
      "last-updated": "Última actualización",
      "delete-x-charts": "Eliminar {{ x }} tablas",
      "assigned-products": "Productos asignados",
      "failed-to-fetch-products-data": "No se pudieron obtener los datos de los productos",
      "delete-chart": "Eliminar tabla",
      "are-you-sure-you-want-to-delete-selected-chart-s-all-products-using-chart-s-will-be-unassigned": "¿Seguro que quieres eliminar la(s) tabla(s) seleccionada(s)? Todos los productos que usen esta(s) tabla(s) quedarán sin asignar.",
      "successfully-deleted-chart-s": "¡Tabla(s) eliminada(s) correctamente!",
      "successfully-duplicated-chart": "¡Tabla duplicada correctamente!",
      "turn-this-into-a-conversion-chart": "Convertir esto en una tabla de conversión",
      "upgradable-tooltip": "Esta tabla de cuadrícula parece una tabla de tallas estructurada y se puede convertir.",
      "convert-to-size-chart": "Convertir en tabla de tallas",
      "convertibility-failed": "No pudimos comprobar qué tablas de cuadrícula se pueden convertir.",
      "convert": {
        "table-chart-info-callout": "Esta tabla de cuadrícula se puede convertir en una tabla de tallas inteligente",
        "table-chart-info-callout-message": "Convertir asigna tu cuadrícula a dimensiones de tu biblioteca, desbloqueando una guía visual de medidas e información del modelo que una tabla plana no puede mostrar.",
        "successfully-converted": "¡Convertida correctamente a tabla de tallas!",
        "detected-sizes": "Tallas detectadas",
        "at-least-two-sizes-are-needed": "Se necesitan al menos dos tallas para convertir esta tabla.",
        "unnamed-row": "Fila sin nombre",
        "ignore-this-row": "Ignorar esta fila",
        "this-dimension-is-already-mapped": "Esta dimensión ya está asignada a otra fila.",
        "map-at-least-one-row": "Asigna al menos una fila a una dimensión.",
        "finish-your-measurement-guide": "Completa tu guía de medidas",
        "measurement-points-without-values": "Puntos de medida sin valores ({{ x }})",
        "fill-them-in-after-converting": "Tu imagen seleccionada los muestra, pero tu tabla no tenía esas filas. Complétalos después de convertir.",
        "measurements-without-points": "Medidas sin un punto en tu imagen ({{ x }})",
        "no-image-selected-yet": "Aún no se ha seleccionado ninguna imagen",
        "upload-an-image-then-drag-points": "Sube una imagen y luego arrastra y suelta los puntos de medida sobre ella.",
        "your-image-has-no-measurement-points": "Tu imagen seleccionada aún no tiene puntos de medida",
        "drag-measurement-points-onto-the-image": "Arrastra y suelta sus puntos de medida sobre la imagen para que los compradores vean dónde medir.",
        "plus-x-more": "+{{ x }} más",
        "satisfied-button": "Se ve bien: hacer esta mi tabla activa",
        "satisfied-explanation": "Tu tabla de cuadrícula se despublicará, esta tabla se publicará y sus productos asignados se trasladarán.",
        "satisfied-success": "¡Esta tabla ya está activa!",
        "step-x-of-y": "Paso {{ x }} de {{ y }}",
        "choose-product-type": "Elige el tipo de producto",
        "well-match-your-table-to-a-visual": "Haremos coincidir tu tabla con el producto visual adecuado.",
        "save-settings": "Guardar configuración",
        "review-table-mapping": "Revisar asignación de tabla",
        "confirm-the-rows-to-convert": "Confirma las filas que debemos convertir.",
        "existing-table": "Tabla existente",
        "sizes": "Tallas",
        "row": "Fila",
        "column": "Columna",
        "x-rows-need-review": "{{ x }} filas necesitan revisión",
        "couldnt-match-this-row": "No pudimos hacer coincidir esta medida automáticamente",
        "change-match": "Cambiar coincidencia",
        "view-values": "Ver valores",
        "hide-values": "Ocultar valores",
        "matched-automatically": "Coincidencia automática",
        "edit-matches": "Editar coincidencias",
        "create-preview": "Crear vista previa",
        "preview-ready": "Vista previa lista",
        "open-it-to-finish-the-missing-values": "Ábrela para completar los valores que faltan.",
        "converted": "Convertido",
        "open-preview": "Abrir vista previa",
        "you-can-add-them-in-the-preview": "Puedes añadirlos en la vista previa."
      }
    },
    "inventory": {
      "collect-emails-and-send-automatic-back-in-stock-notifications-setup-notification": "Recopila correos electrónicos y envía notificaciones automáticas de reabastecimiento. Configurar notificación",
      "here": "aquí",
      "successfully-export-inventory-data": "Datos de inventario exportados correctamente",
      "active-your-store-inventory-notification-feature": "Activa la función de notificación de inventario de tu tienda",
      "in-order-to-receive-users-subscribed-for-your-products": "para recibir usuarios suscritos a tus productos.",
      "your-subscribers-have-been-delegeted-to-your": "Tus suscriptores han sido delegados a tu"
    },
    "setting": {
      "storefront-popup-preview": "Vista previa de la ventana emergente de la tienda",
      "add-to-cart": "Añadir al carrito",
      "buy-now": "Comprar ahora",
      "sans-serif": "Sans serif",
      "serif": "Serif",
      "email-body-is-required": "El cuerpo del correo es obligatorio",
      "list": "Lista",
      "category-image": "Imagen de categoría",
      "pay-over-usage-cost": "Pagar el coste de uso excedente",
      "over-usage-count": "Recuento de uso excedente",
      "over-usage-cost": "Coste de uso excedente",
      "x-usages": "{{ x }} usos",
      "failed-to-pay-over-usage-cost": "No se pudo pagar el coste de uso excedente",
      "manage-your-personal-information-and-account-perferences": "Gestiona tu información personal y preferencias de cuenta.",
      "manage-your-organization-contact-information-and-address": "Gestiona la información de contacto y la dirección de tu organización.",
      "manage-your-billing-overview": "Revisa los detalles de facturación, plan e información de pago.",
      "manage-your-plan-and-usage": "Consulta tu plan actual y los límites de uso.",
      "manage-your-measurement-dimensions": "Gestiona las dimensiones de medida usadas en tus tablas de tallas.",
      "dimension-translations": "Traducciones de la tienda",
      "dimension-translations-description": "Introduce la etiqueta que verán los compradores para cada idioma de tienda compatible. Déjalo en blanco para usar el nombre predeterminado.",
      "default-dimension-name": "Nombre de dimensión predeterminado",
      "dimension-name-description": "Se usa en todo el panel y como valor de reserva en la tienda cuando no se proporciona traducción.",
      "storefront-label": "Etiqueta de la tienda",
      "naming": "Nombres",
      "affecting-data": "Datos afectados",
      "first-name-is-required": "El nombre es obligatorio",
      "last-name-is-required": "El apellido es obligatorio",
      "subscribed-for-our-latest-news-exclusive-offers-and-exciting-updates": "Suscrito para recibir nuestras últimas noticias, ofertas exclusivas y novedades interesantes.",
      "contact-information": "Información de contacto",
      "contact-name": "Nombre de contacto",
      "contact-name-is-required": "¡El nombre de contacto es obligatorio!",
      "contact-email": "Correo de contacto",
      "contact-email-is-required": "¡El correo de contacto es obligatorio!",
      "contact-email-is-invalid": "¡El correo de contacto no es válido!",
      "company-organization-name": "Nombre de la empresa/organización",
      "company-organization-name-is-required": "El nombre de la empresa/organización es obligatorio",
      "street-address": "Dirección",
      "street-address-is-required": "¡La dirección es obligatoria!",
      "street-address-2": "Dirección 2",
      "city": "Ciudad",
      "city-is-required": "¡La ciudad es obligatoria!",
      "state-province-region": "Estado/Provincia/Región",
      "state-province-region-is-required": "¡El estado/provincia/región es obligatorio!",
      "country": "País",
      "country-is-required": "¡El país es obligatorio!",
      "postal-zip-code": "Código postal",
      "postal-zip-code-is-required": "¡El código postal es obligatorio!",
      "themes": "Temas",
      "customise-your-app-look-choose-a-colour-that-best-represents-your-brand": "¡Personaliza el aspecto de tu app! Elige un color que represente mejor tu marca",
      "sunset-ember": "Ámbar atardecer",
      "classic-noir": "Negro clásico",
      "system-background-colour": "Color de fondo del sistema",
      "customise-your-button": "Personaliza tu botón",
      "customise-your-button-text-colour-and-style-to-match-your-brand": "Personaliza el texto, color y estilo de tu botón para que coincida con tu marca.",
      "what-should-the-button-say": "¿Qué debería decir el botón?",
      "label-button-is-required": "¡La etiqueta del botón es obligatoria!",
      "text-colour": "Color de texto",
      "text-colour-is-required": "¡El color de texto es obligatorio!",
      "please-input-valid-hex-color-code": "Introduce un código de color hexadecimal válido",
      "background-color": "Color de fondo",
      "background-colour-is-required": "¡El color de fondo es obligatorio!",
      "font-size-in-px": "Tamaño de fuente en px",
      "font-size-in-px-is-required": "¡El tamaño de fuente en px es obligatorio!",
      "border-radius": "Radio del borde",
      "border-radius-is-required": "¡El radio del borde es obligatorio!",
      "successfully-updated-button-style": "Estilo del botón actualizado correctamente",
      "font-family": "Familia de fuente",
      "customise-your-font": "Personaliza tu fuente",
      "match-your-store-look-and-feel-by-updating-the-font-across-your-size-charts": "Combina el estilo de tu tienda actualizando la fuente en todas tus tablas de tallas.",
      "select-a-font-from-the-list-bellow": "Selecciona una fuente de la lista de abajo.",
      "search-font": "Buscar fuente...",
      "fetching-fonts": "Obteniendo fuentes...",
      "showing-x-fonts": "Mostrando {{ x }} fuentes",
      "sort-by-x": "Ordenar por {{ x }}",
      "most-popular": "Más popular",
      "here-how-it-will-look-on-your-shop": "Así se verá en tu tienda",
      "it-ll-updated-across-all-your-chart-displays": "Se actualizará en todas las visualizaciones de tus tablas.",
      "update-font-across-all-size-charts": "Actualizar la fuente en todas las tablas de tallas",
      "choose-a-font-to-match-your-store-style": "Elige una fuente que combine con el estilo de tu tienda",
      "apply-font": "Aplicar fuente",
      "font-applied-successfully": "¡Fuente aplicada correctamente!",
      "manage-and-delete-your-uploaded-images-removing-a-file-is-permanent-and-cannot-be-undone": "Gestiona y elimina tus imágenes subidas. Eliminar un archivo es permanente y no se puede deshacer.",
      "do-you-want-to-delete-image": "¿Quieres eliminar la imagen?",
      "image-deleted-successfully": "Imagen eliminada correctamente",
      "chart-list": "Lista de tablas",
      "delete-x-dimensions": "Eliminar {{ x }} dimensiones",
      "view-affecting-data": "Ver datos afectados",
      "no-data-will-be-affected": "No se verán afectados datos.",
      "do-you-want-to-delete-selected-dimensions": "¿Quieres eliminar las dimensiones seleccionadas?",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-annotation-and-data-removed": "A cualquier conjunto de anotaciones y tabla que use actualmente estas dimensiones se le eliminarán sus anotaciones y datos",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-name-changed": "A cualquier conjunto de anotaciones y tabla que use actualmente estas dimensiones se le cambiará el nombre",
      "delete-dimension": "Eliminar dimensión",
      "successfully-deleted-dimension": "¡Dimensión(es) eliminada(s) correctamente!",
      "successfully-update-dimension": "¡Dimensión actualizada correctamente!",
      "configure-how-back-in-stock-notifications-work-for-your-customers": "Configura cómo funcionan las notificaciones de reabastecimiento para tus clientes",
      "activate-back-in-stock-notifications": "Activar notificaciones de reabastecimiento",
      "allow-shoppers-to-subscribe-for-alerts-when-a-size-or-product-is-sold-out-notifications-will-be-sent-automatically-once-stock-is-available": "Permite que los compradores se suscriban a alertas cuando una talla o producto se agote. Las notificaciones se enviarán automáticamente cuando haya stock disponible.",
      "notification-channels": "Canales de notificación",
      "third-party-service": "Servicio de terceros",
      "sms": "SMS",
      "coming-soon": "Próximamente",
      "signup-experience-design": "Diseño de la experiencia de registro",
      "form-display": "Visualización de formulario",
      "modal-popup": "Ventana modal emergente",
      "email-template-customisation": "Personalización de plantilla de correo",
      "subject-line": "Línea de asunto",
      "subject-line-is-required": "La línea de asunto es obligatoria",
      "your-size-is-back-in-stock": "¡Tu talla ya está disponible de nuevo! 🎉",
      "email-body": "Cuerpo del correo",
      "inventory-threshold-setting": "Configuración del umbral de inventario",
      "notify-shoppers-when-inventory-reaches-at-least": "Notificar a los compradores cuando el inventario alcance al menos",
      "threshold-is-required": "El umbral es obligatorio",
      "threshold-must-be-greater-than-0": "El umbral debe ser mayor que 0",
      "units": "unidades",
      "set-the-minimum-inventory-level-required-to-trigger-notifications": "Establece el nivel mínimo de inventario necesario para activar las notificaciones",
      "choose-a-service": "Elige un servicio",
      "signing-out": "Cerrando sesión",
      "signout-of": "Cerrar sesión de",
      "authenticate": "Autenticar",
      "save-settings": "Guardar configuración",
      "hi-your-is-now-back-in-stock-get-it-before-it-gone": "Hola {{first_name}}, tu {{product_name}} ({{size_variant}}) ya está de nuevo en stock. ¡Consíguelo antes de que se agote!",
      "successfully-updated-notification-back-in-stock": "Notificación de reabastecimiento actualizada correctamente",
      "preferred-language": "Idioma preferido",
      "successfully-updated-your-profile": "Tu perfil se actualizó correctamente",
      "successfully-updated-mailing-subscription-status": "¡Estado de suscripción de correo actualizado correctamente!",
      "upgrade-plan": "Mejorar plan",
      "overview": "Resumen",
      "billing-cycle": "Ciclo de facturación",
      "billing-cycle-resets-at-midnight-on-x-and-the-next-charge-is-on-y": "El ciclo de facturación se reinicia a medianoche el {{ x }} y el próximo cargo es el {{ y }}",
      "billing-information": "Información de facturación",
      "update-billing": "Actualizar facturación",
      "monthly-total": "Total mensual",
      "free-trial-x-days-left": "Prueba gratuita - quedan {{ x }} días",
      "cancel-plan": "Cancelar plan",
      "change-plan": "Cambiar plan",
      "plan-and-usage": "Plan y uso",
      "tier-offers-in-use": "Ofertas de nivel en uso",
      "failed-to-cancel-plan": "No se pudo cancelar el plan",
      "total-usage": "Uso total",
      "current-usage-summary": "Resumen de uso actual",
      "published-charts": "Tablas publicadas",
      "limit-reached": "límite alcanzado",
      "plan-details": "Detalles del plan",
      "current-plan": "Plan actual",
      "select-a-reason": "Selecciona un motivo",
      "please-provide-your-reason": "Indica tu motivo",
      "chart-preferences": "Preferencias de tabla",
      "skip-picking-dimensions-when-creating-a-new-chart-from-template": "Omitir la selección de dimensiones al crear una nueva tabla desde una plantilla",
      "border-color": "Color del borde",
      "border-color-is-required": "¡El color del borde es obligatorio!",
      "list-of-charts-using-this-image": "Lista de tablas que usan esta imagen",
      "successfully-update-your-profile": "Tu perfil se actualizó correctamente"
    },
    "analytic": {
      "failed-to-load-statistics": "No se pudieron cargar las estadísticas",
      "total-chart-views": "Vistas de tabla",
      "total-add-to-cart": "Añadidos al carrito",
      "traffic-by-location": "Tráfico por ubicación",
      "desktop": "Escritorio",
      "mobile": "Móvil",
      "size-recommendations": {
        "failed-to-load": "No se pudieron cargar las analíticas de recomendaciones de talla",
        "total-suggestions-title": "Sugerencias realizadas",
        "conversion-title": "Conversión",
        "customers-proceeded": "Clientes que continuaron con la sugerencia",
        "of-x-suggestions": "de {{count}} sugerencias",
        "most-suggested-title": "Producto y variante más sugeridos",
        "suggestions-count": "{{count}} sugerencias",
        "most-common-profile-title": "Perfil más común",
        "average-profile-title": "Perfil promedio",
        "gender": "Género",
        "age-group": "Grupo de edad",
        "height": "Altura",
        "weight": "Peso",
        "size-recommended": "Talla recomendada",
        "graph-suggestions": "Sugerencias",
        "graph-proceed": "Continuar",
        "source-all": "Todo",
        "source-chart": "Tabla de tallas",
        "source-table-chart": "Tabla de cuadrícula"
      },
      "chart-views": {
        "failed-to-load": "No se pudieron cargar las vistas de tabla",
        "device-types": "Tipos de dispositivo",
        "most-viewed-chart": "Tabla más vista",
        "most-viewed-product": "Producto más visto",
        "views-count": "{{ count }} vistas",
        "view-at": "Vista en",
        "location": "Ubicación",
        "graph-label": "Vistas"
      },
      "add-to-cart": {
        "failed-to-load": "No se pudieron cargar las analíticas de añadidos al carrito",
        "estimated-revenue": "Valor estimado influenciado",
        "conversion-title": "Conversión de ver tabla → añadir al carrito",
        "most": "Más añadidos al carrito",
        "adds-count": "{{count}} añadidos al carrito",
        "added-at": "Añadido el",
        "graph-label": "Añadidos al carrito",
        "views-dataset-label": "Vistas",
        "add-to-cart-dataset-label": "Añadir al carrito"
      },
      "stock-notifications": {
        "failed-to-load": "No se pudieron cargar las analíticas de notificaciones de stock",
        "failed-to-load-table": "No se pudo cargar la tabla de notificaciones de stock",
        "total-subscriptions": "Suscripciones",
        "total-notifications-sent": "Notificaciones enviadas",
        "delivery-rate": "Tasa de entrega",
        "opened-of-notified": "{{ opened }} abiertas / {{ notified }} notificadas",
        "most-subscribed": "Más suscrito",
        "subscriptions-count": "{{ count }} suscripciones",
        "latest-subscribed": "Última suscripción",
        "subscribed-at": "Suscrito el: {{ date }}",
        "longest-waiting": "Más tiempo esperando reabastecimiento",
        "waiting-days": "Esperando: {{ days }} días",
        "waiting-since": "(desde {{ date }})",
        "subscriptions": "Suscripciones",
        "notifications-sent": "Notificaciones enviadas",
        "opened": "Abiertas",
        "at": "En",
        "graph-label": "Suscripciones"
      },
      "paid-gate": {
        "unlock-message": "Desbloquea analítica avanzada para ver todos los datos y tomar mejores decisiones.",
        "upgrade": "Mejorar",
        "failed-to-fetch-plans": "No se pudieron obtener los planes"
      },
      "buy-now": {
        "failed-to-load": "No se pudieron cargar las analíticas de compra ahora",
        "total": "Compras ahora",
        "estimated-revenue": "Valor estimado influenciado",
        "conversion-title": "Conversión de ver tabla → comprar ahora",
        "most": "Producto más comprado con Comprar ahora",
        "buys-count": "{{count}} compras ahora",
        "graph-label": "Compras ahora",
        "views-dataset-label": "Vistas",
        "buy-now-dataset-label": "Comprar ahora",
        "clicked-at": "Clic en"
      },
      "overview": {
        "funnel-title": "En qué acabaron las vistas de tabla",
        "no-views-title": "Sin vistas de tabla en este periodo",
        "no-views-hint": "Las tablas de tallas aparecen en las páginas de producto una vez publicadas y asignadas a productos.",
        "chart-views-caption": "Compradores que abrieron una tabla de tallas",
        "baseline-caption": "Todo lo siguiente se mide sobre estas vistas",
        "of-views": "de {{ count }} vistas",
        "not-in-funnel": "Fuera del embudo de la tabla"
      },
      "preview": {
        "title": "Aún no hay datos — esto es una vista previa",
        "message": "Las cifras siguientes son datos de ejemplo que muestran cómo se verá esta página cuando los compradores empiecen a usar tus tablas de tallas."
      }
    },
    "plans": {
      "popular-plan": "Plan popular",
      "try-now": "Probar ahora",
      "activated": "Activado",
      "contact-sales": "Contactar con ventas",
      "try-free-for-1-month": "Prueba gratis por 1 mes",
      "activate": "Activar",
      "what-included": "¿Qué incluye?",
      "choose-the-plan-that-fits-your-business-needs": "Elige el plan que se ajuste a las necesidades de tu negocio",
      "whether-youre-just-starting-out-or-looking-for-a-robust-sizing-solution-weve-got-a-plan-thats-right-for-you": "Ya sea que estés empezando o busques una solución de tallaje robusta, tenemos un plan adecuado para ti.",
      "monthly": "Mensual",
      "annually": "Anual",
      "compare-plan-features": "Comparar características de los planes",
      "compare-all-plan-features": "Comparar todas las características de los planes",
      "feature-usages": "Usos",
      "feature-analytics": "Analíticas",
      "feature-support": "Soporte",
      "feature-integration": "Integración",
      "feature-branding": "Marca",
      "feature-api-access": "Acceso a la API",
      "feature-stock-notifications": "Notificaciones de stock",
      "feature-published-conversion-charts": "Tablas de conversión publicadas",
      "feature-advanced-variant-mapping": "Asignación avanzada de variantes",
      "failed-to-fetch-plans": "No se pudieron obtener los planes",
      "failed-to-activate-plan": "No se pudo activar el plan",
      "contact": {
        "title": "Contactar con ventas",
        "subtitle": "Cuéntanos sobre tu tienda y lo que necesitas. Nuestro equipo te responderá por correo electrónico.",
        "message-placeholder": "¿Cómo podemos ayudar a tu negocio?",
        "send": "Enviar mensaje",
        "success": "¡Gracias! Tu mensaje se ha enviado. Nuestro equipo se pondrá en contacto contigo pronto.",
        "first-name-required": "El nombre es obligatorio",
        "last-name-required": "El apellido es obligatorio",
        "email-required": "El correo electrónico es obligatorio",
        "email-invalid": "El correo electrónico no es válido",
        "message-required": "El mensaje es obligatorio"
      },
      "invite": {
        "title": "Completa tu suscripción",
        "your-plan": "Tu plan",
        "order-summary": "Resumen del pedido",
        "billed-every-30-days": "Facturado cada 30 días",
        "billed-yearly": "Facturado anualmente",
        "free-trial": "Prueba gratuita de {{days}} días",
        "due-today": "A pagar hoy",
        "then-every-30-days": "Después, {{price}} USD cada 30 días",
        "then-yearly": "Después, {{price}} USD al año",
        "continue": "Continuar a la aprobación",
        "shopify-note": "Facturado a través de Shopify. Aprobarás el cargo en la siguiente pantalla.",
        "switching-note": "Esto reemplaza tu plan actual cuando lo apruebes. Shopify aplica el crédito por el tiempo restante.",
        "already-on-plan": "Ya tienes este plan",
        "unavailable-title": "Esta invitación ya no está disponible",
        "unavailable-body": "Es posible que el enlace haya caducado. Contacta con quien te lo envió o consulta los planes abiertos a todas las tiendas.",
        "see-plans": "Ver planes",
        "failed-title": "No se pudo cargar este plan",
        "failed-body": "Comprueba tu conexión y vuelve a cargar la página."
      }
    },
    "auth": {
      "signin": {
        "please-sign-in": "Por favor, inicia sesión",
        "email-is-required": "El correo electrónico es obligatorio",
        "invalid-email-address": "Dirección de correo no válida",
        "password-is-required": "La contraseña es obligatoria",
        "sign-in": "Iniciar sesión",
        "reset-password": "Restablecer contraseña",
        "generic-error": "¡Hubo un error en el proceso! Inténtalo de nuevo más tarde."
      }
    },
    "admin": {
      "reports": {
        "title": "Informes",
        "chart-views": {
          "title": "Vistas de tabla",
          "description": "Consulta cuántas veces los compradores abrieron la tabla de tallas, globalmente en todas las tiendas.",
          "failed-to-load": "No se pudo cargar el informe de vistas de tabla",
          "total-views": "Vistas de tabla",
          "most-viewed-chart": "Tabla más vista",
          "most-viewed-product": "Producto más visto",
          "views-count": "{{ count }} vistas",
          "traffic-by-location": "Tráfico por ubicación",
          "device-types": "Tipos de dispositivo",
          "desktop": "Escritorio",
          "mobile": "Móvil",
          "top-stores": "Tiendas principales",
          "no-top-stores": "Aún no hay datos de tiendas",
          "graph-label": "Vistas",
          "view-at": "Vista en",
          "location": "Ubicación"
        },
        "add-to-cart": {
          "title": "Añadir al carrito",
          "description": "Consulta cómo influye la tabla de tallas en los eventos de añadir al carrito, globalmente en todas las tiendas.",
          "failed-to-load": "No se pudo cargar el informe de añadidos al carrito",
          "total-add-to-cart": "Añadidos al carrito",
          "conversion-title": "Conversión de ver tabla → añadir al carrito",
          "most": "Más añadidos al carrito",
          "adds-count": "{{ count }} añadidos al carrito",
          "top-stores": "Tiendas principales",
          "no-top-stores": "Aún no hay datos de tiendas",
          "graph-label": "Añadidos al carrito",
          "views-dataset-label": "Vistas",
          "add-to-cart-dataset-label": "Añadir al carrito",
          "added-at": "Añadido el"
        },
        "buy-now": {
          "title": "Comprar ahora",
          "description": "Consulta cómo influye la tabla de tallas en los eventos de comprar ahora, globalmente en todas las tiendas.",
          "failed-to-load": "No se pudo cargar el informe de compra ahora",
          "total-buy-now": "Compras ahora",
          "conversion-title": "Conversión de ver tabla → comprar ahora",
          "most": "Producto más comprado con Comprar ahora",
          "buys-count": "{{ count }} compras ahora",
          "top-stores": "Tiendas principales",
          "no-top-stores": "Aún no hay datos de tiendas",
          "graph-label": "Compras ahora",
          "views-dataset-label": "Vistas",
          "buy-now-dataset-label": "Comprar ahora",
          "clicked-at": "Clic en"
        },
        "conversion-funnel": {
          "title": "Conversión de tabla de cuadrícula",
          "description": "Consulta dónde abandonan los comercios al convertir una tabla de cuadrícula en tabla de tallas, globalmente en todas las tiendas.",
          "failed-to-load": "No se pudo cargar el informe de conversión de tabla de cuadrícula",
          "total-runs": "Conversiones iniciadas",
          "runs-breakdown": "{{ converted }} convertidas · {{ handedOver }} entregadas",
          "conversion-title": "Iniciado → Convertido",
          "handover-rate": "El {{ rate }}% continuó y entregó sus productos",
          "handover-gap-title": "Convertido, sin entregar",
          "of-converted-runs": "de intentos convertidos",
          "handover-gap-description": "Una entrega puede ocurrir días después, así que algunas de estas están pendientes en lugar de abandonadas.",
          "funnel-title": "Embudo de conversión",
          "funnel-note": "El paso dedicado de entrega ya no se activa: el banner es ahora cómo se completan las entregas, así que interpreta su recuento como el total de entregas en lugar de una conversión de paso.",
          "no-funnel": "No hay intentos de conversión en este rango",
          "drop-off": "abandono",
          "runs-dataset-label": "Intentos",
          "drop-offs-title": "Dónde terminan los intentos",
          "drop-offs-description": "Lo último que hizo cada intento. Los intentos que terminan en una entrega completada (ahora registrada mediante el banner) finalizaron con éxito.",
          "no-drop-offs": "No hay intentos de conversión en este rango",
          "dwell-title": "Tiempo antes de salir",
          "dwell-description": "Solo se registra cuando un comercio abandona un paso, más el tiempo dedicado a leer la revisión antes de confirmar.",
          "no-dwell": "No hay datos de tiempo en este rango",
          "step": "Paso",
          "samples": "Muestras",
          "median": "Mediana",
          "p90": "P90",
          "top-stores": "Tiendas principales",
          "no-top-stores": "Aún no hay datos de tiendas",
          "graph-label": "Conversiones iniciadas",
          "started-at": "Iniciado el",
          "duration": "Duración",
          "last-step": "Último paso",
          "outcome": "Resultado",
          "steps": {
            "entry": "Diálogo abierto",
            "category": "Categoría",
            "mapping": "Asignación",
            "summary": "Revisión",
            "convert": "Convertir",
            "handover": "Entrega",
            "banner": "Banner"
          },
          "actions": {
            "viewed": "visto",
            "completed": "completado",
            "skipped": "omitido",
            "back": "retrocedió",
            "abandoned": "abandonado",
            "failed": "fallido",
            "customize_clicked": "clic en personalizar",
            "dismissed": "descartado"
          },
          "outcomes": {
            "handed-over": "Entregado",
            "converted": "Solo convertido",
            "failed": "Fallido",
            "abandoned": "Abandonado",
            "in-progress": "En progreso"
          }
        }
      },
      "delete-category": "Eliminar categoría",
      "do-you-want-to-delete-selected-categories": "¿Quieres eliminar las categorías seleccionadas?",
      "global-categories-are-shared-by-every-store": "Las categorías globales se comparten entre todas las tiendas: eliminar una las afecta a todas. Esto no se puede deshacer.",
      "successfully-deleted-category": "Categoría eliminada correctamente",
      "average-cost-per-recommendation": "Coste medio por recomendación",
      "failed-to-load-recommendations-average-cost": "No se pudo cargar el coste medio de recomendaciones",
      "most-expensive-extract": "Extracción más costosa",
      "most-expensive-recommendation": "Recomendación más costosa",
      "total-recommendation-cost": "Coste total de recomendaciones",
      "total-size-recommendation": "Recomendaciones de talla",
      "total-sheet-extract": "Extracciones de hoja",
      "new-category": "Nueva categoría",
      "category-created-unlisted-hint": "La categoría se crea sin listar. Añade una imagen y medidas antes de publicarla en las tiendas.",
      "category-created-successfully": "¡Categoría creada correctamente!",
      "category-search-placeholder": "Nombre de imagen, nombre de tienda...",
      "dimension-search-placeholder": "Nombre de dimensión, nombre de tienda...",
      "category-not-found": "Categoría no encontrada",
      "sub-categories-variants": "Subcategorías/variantes:",
      "add-sub-category-variant": "Añadir subcategoría/variante:",
      "from-existing": "Desde existente",
      "create-a-new": "Crear una nueva",
      "sub-category-removed": "¡Subcategoría eliminada!",
      "remove-sub-category": "Eliminar subcategoría",
      "remove-sub-category-confirm": "¿Eliminar {{ x }} de esta categoría? Seguirá disponible como categoría de nivel superior.",
      "update-category": "Actualizar categoría",
      "published-category-hint": "Una categoría publicada es visible para todas las tiendas. Las categorías sin listar permanecen ocultas.",
      "category-updated-successfully": "¡Categoría actualizada correctamente!",
      "uninstalled": "Desinstalado",
      "inactive": "Inactivo",
      "install-at": "Instalado el",
      "total-chart-views": "Vistas de tabla",
      "chart-view-at": "Vista de tabla en",
      "store-id": "ID de tienda",
      "successfully-deleted-clients": "¡Clientes eliminados correctamente!",
      "session-replay": "Repetición de sesión",
      "watch-on-amplitude": "Ver en Amplitude",
      "shopify-app": "App de Shopify",
      "shops-online-store": "Tienda en línea de la tienda",
      "no-more-events-to-load": "¡No hay más eventos para cargar!",
      "failed-to-fetch-events": "¡No se pudieron obtener los eventos!",
      "info": "Información",
      "store-info": "Información de la tienda",
      "days-ago": "hace {{ x }} días",
      "contact-email": "Correo de contacto",
      "store-url": "URL de la tienda",
      "activities": "Actividades",
      "insights": "Perspectivas",
      "subscriptions": "Suscripciones",
      "failed-to-fetch-client-info": "¡No se pudo obtener la información del cliente!",
      "failed-to-load-add-to-cart-analytics": "No se pudieron cargar las analíticas de añadidos al carrito",
      "failed-to-load-buy-now-analytics": "No se pudieron cargar las analíticas de compra ahora",
      "failed-to-load-chart-views": "No se pudieron cargar las vistas de tabla",
      "failed-to-load-size-recommendations-analytics": "No se pudieron cargar las analíticas de recomendaciones de talla",
      "failed-to-load-stock-notifications-analytics": "No se pudieron cargar las analíticas de notificaciones de stock",
      "failed-to-load-stock-notifications-table": "No se pudo cargar la tabla de notificaciones de stock",
      "chart-views": "Vistas de tabla",
      "add-to-cart": "Añadir al carrito",
      "buy-now": "Comprar ahora",
      "size-recommendations": "Recomendaciones de talla",
      "stock-notifications": "Notificaciones de stock",
      "change-details": "Cambiar detalles",
      "plan-subscription-details": "Detalles de la suscripción al plan",
      "ai-size-recommendation-limit": "Límite de recomendaciones de talla con IA",
      "ai-size-recommendation-limit-required": "¡El límite de recomendaciones de talla con IA es obligatorio!",
      "minimum-limit-is-0": "¡El límite mínimo es 0!",
      "unlimited": "Ilimitado",
      "chart-limit-drafts-hint": "Solo cuentan las tablas publicadas. Los borradores son ilimitados.",
      "chart-limit-required": "¡El límite de tablas es obligatorio!",
      "chart-limit-whole-number": "¡El límite debe ser un número entero!",
      "stock-notification-limit": "Límite de notificaciones de stock",
      "stock-notification-limit-required": "¡El límite de notificaciones de stock es obligatorio!",
      "published-size-chart-limit": "Límite de tablas de tallas publicadas",
      "published-table-chart-limit": "Límite de tablas de cuadrícula publicadas",
      "analytic": "Analítica",
      "full-suite": "Suite completa",
      "select-a-subscription-plan": "Selecciona un plan de suscripción",
      "failed-to-fetch-plans": "¡No se pudieron obtener los planes!",
      "new-plan": "Nuevo plan",
      "failed-to-assign-plan-subscription-to-client": "¡No se pudo asignar la suscripción del plan al cliente!",
      "ai-size-recommendation": "Recomendación de talla con IA",
      "stock-notification": "Notificación de stock",
      "published-size-charts": "Tablas de tallas publicadas",
      "published-table-charts": "Tablas de cuadrícula publicadas",
      "analytic-access": "Acceso a analítica",
      "activated-at": "Activado el",
      "usages": "Usos",
      "failed-to-fetch-client-plan-subscription": "¡No se pudo obtener la suscripción del plan del cliente!",
      "advanced-variant-mapping": "Asignación avanzada de variantes",
      "advanced-variant-mapping-description": "Las tablas usan sus propias tallas en cada producto asignado, y Añadir al carrito elige la variante de producto correspondiente. Si está desactivada, las tallas de una tabla deben coincidir exactamente con los nombres de las variantes de cada producto.",
      "advanced-variant-mapping-counts": "{{ total }} tablas · {{ x }} con asignación avanzada de variantes",
      "advanced-variant-mapping-drift": "{{ x }} tablas no coinciden con este ajuste.",
      "advanced-variant-mapping-repair": "Reparar",
      "turn-on-advanced-variant-mapping": "¿Activar la asignación avanzada de variantes?",
      "turn-off-advanced-variant-mapping": "¿Desactivar la asignación avanzada de variantes?",
      "advanced-variant-mapping-on-body": "Las {{ x }} tablas de este cliente cambian de inmediato, y las tablas nuevas también la usarán. Las medidas no se modifican y puedes volver a desactivarla.",
      "advanced-variant-mapping-off-body": "Las {{ x }} tablas de este cliente vuelven a la coincidencia exacta de nombres de variantes. Las tablas cuyas tallas se renombraron mientras estaba activada (p. ej., «Blue / S» a «S») mostrarán medidas vacías en los productos cuyos nombres de variantes ya no coincidan.",
      "turn-on": "Activar",
      "turn-off": "Desactivar",
      "failed-to-fetch-advanced-variant-mapping": "¡No se pudo obtener la asignación avanzada de variantes!",
      "failed-to-update-advanced-variant-mapping": "¡No se pudo actualizar la asignación avanzada de variantes!",
      "plan-used-as-free-trial": "Plan usado como prueba gratuita para nuevos clientes registrados",
      "x-usages": "{{ x }} usos",
      "successfully-updated-configuration-value": "Valor de configuración actualizado correctamente",
      "only-authorized-personnel-hint": "¡Solo el personal autorizado puede acceder y modificar la configuración global de la aplicación!",
      "password-is-required": "La contraseña es obligatoria",
      "authorize": "Autorizar",
      "1-month": "1 mes",
      "3-months": "3 meses",
      "6-months": "6 meses",
      "1-year": "1 año",
      "failed-to-load-costs": "No se pudieron cargar los costes",
      "failed-to-load-total-recommendations": "No se pudo cargar el total de recomendaciones",
      "archived": "Archivado",
      "billing-interval": "Intervalo de facturación",
      "plan-information": "Información del plan",
      "name-is-required": "¡El nombre es obligatorio!",
      "features": "Características",
      "stock-notification-recommendation-limit": "Límite de recomendaciones de notificación de stock",
      "popular": "Popular",
      "allow-trial": "Permitir prueba",
      "interval": "Intervalo",
      "interval-is-required": "¡El intervalo es obligatorio!",
      "price-is-required": "¡El precio es obligatorio!",
      "minimum-price-is-0": "¡El precio mínimo es 0!",
      "discounted-from": "Descontado desde",
      "description": "Descripción",
      "description-is-required": "¡La descripción es obligatoria!",
      "selling-points": "Puntos de venta",
      "selling-point-x": "Punto de venta {{ x }}",
      "selling-point-is-required": "¡El punto de venta es obligatorio!",
      "analytic-is-required": "¡La analítica es obligatoria!",
      "support": "Soporte",
      "support-is-required": "¡El soporte es obligatorio!",
      "status-is-required": "¡El estado es obligatorio!",
      "manage-preset-dimensions": "Gestiona las dimensiones predefinidas, sus sinónimos de detección y traducciones.",
      "detection-synonyms": "Sinónimos de detección",
      "add-synonym-placeholder": "Escribe un sinónimo y presiona Enter",
      "translations": "Traducciones",
      "missing-translation": "Traducción faltante",
      "new-dimension": "Nueva dimensión",
      "edit-dimension": "Editar dimensión",
      "delete-preset-dimension": "Eliminar dimensión predefinida",
      "do-you-want-to-delete-this-preset-dimension": "¿Quieres eliminar \"{{ name }}\"?",
      "preset-dimensions-are-shared-by-every-store": "Las dimensiones predefinidas se comparten entre todas las tiendas: eliminar una la elimina de todas las categorías que la usan. Esto no se puede deshacer.",
      "successfully-created-dimension": "¡Dimensión creada correctamente!",
      "successfully-updated-dimension": "¡Dimensión actualizada correctamente!",
      "successfully-deleted-dimension": "¡Dimensión eliminada correctamente!",
      "ai-provider-for-file-imports": "Proveedor de IA para importaciones de archivos",
      "no-api-key-configured-in-this-environment": "No hay ninguna clave de API configurada en este entorno",
      "ai-provider-saved-applies-to-new-imports": "Proveedor de IA guardado. Se aplica a las nuevas importaciones; las que ya están en curso mantienen su proveedor.",
      "ai-provider-for-size-recommendations": "Proveedor de IA para recomendaciones de talla",
      "ai-provider-saved-applies-to-next-recommendation": "Proveedor de IA guardado. Se aplica a partir de la próxima recomendación de talla.",
      "size-recommendation-provider-hint": "Se usa para las recomendaciones de talla con IA de los compradores. Independiente de las importaciones de archivos.",
      "ai-measurement-import": "Importación de medidas con IA",
      "name-admin-only": "Nombre (solo administradores)",
      "name-admin-only-hint": "La app reconoce los planes Free y Enterprise por este nombre, así que no los renombres.",
      "display-name": "Nombre visible",
      "display-name-hint": "Se muestra a los comerciantes en la página de planes, las páginas de facturación y el cargo de Shopify. Déjalo en blanco para usar el nombre.",
      "display-name-too-long": "¡El nombre visible puede tener como máximo 40 caracteres!",
      "availability": "Disponibilidad",
      "available-from-utc": "Disponible desde (UTC)",
      "available-from-hint": "Déjalo en blanco para ofrecerlo en cuanto esté activo.",
      "expires-at-utc": "Caduca el (UTC)",
      "expires-at-required": "¡Indica cuándo caduca!",
      "window-order": "¡Debe estar disponible antes de caducar!",
      "your-time": "Tu hora: {{time}}",
      "availability-always": "Siempre disponible",
      "availability-scheduled": "Programado: aún no se ofrece",
      "availability-live": "Activo: se ofrece ahora",
      "availability-ended": "Finalizado: ya no se ofrece",
      "promo-plan": "Plan promocional",
      "replaces-plan": "Sustituye a",
      "replaces-plan-none": "Nada (un plan normal)",
      "replaces-plan-hint": "Mientras se ofrece este plan, los comerciantes lo ven en lugar del plan al que sustituye.",
      "campaign": "Campaña",
      "campaign-required": "¡Elige la campaña a la que pertenece este plan promocional!",
      "merchants-see": "Los comerciantes ven",
      "replaces-x": "sustituye a {{x}}",
      "archiving-hint": "Archivar oculta un plan solo a los nuevos suscriptores. Los suscriptores actuales lo conservan.",
      "duplicate-as-promo-plan": "Duplicar como plan promocional",
      "help-articles": {
        "topic": "Tema",
        "all-topics": "Todos los temas",
        "topics": {
          "getting-started": "Primeros pasos",
          "size-charts": "Tablas de tallas",
          "table-charts": "Tablas de cuadrícula",
          "assigning-products": "Asignar a productos",
          "storefront-display": "Visualización en la tienda",
          "chart-import": "Importación de tablas",
          "size-recommendations": "Recomendaciones de talla",
          "plans-billing": "Planes y facturación",
          "troubleshooting": "Solución de problemas"
        },
        "new-article": "Nuevo artículo de ayuda",
        "slug": "Slug",
        "slug-hint": "La dirección del artículo en el centro de ayuda: /help/tu-slug. Si lo cambias, los enlaces a la dirección anterior dejarán de funcionar.",
        "slug-invalid": "Usa letras minúsculas, números y guiones simples.",
        "slug-taken": "Otro artículo ya usa este slug.",
        "title-is-required": "El título es obligatorio",
        "summary": "Resumen",
        "summary-hint": "Una línea. El asistente de soporte elige los artículos por su resumen.",
        "summary-is-required": "El resumen es obligatorio",
        "order": "Orden",
        "body-hint": "Markdown. Enlaza otro artículo con [texto](/help/su-slug).",
        "insert-image": "Insertar imagen",
        "image-upload-failed": "No se pudo subir la imagen.",
        "view-on-help-centre": "Ver en el centro de ayuda",
        "broken-links": "Publicado, pero estos enlaces apuntan a artículos que no existen o no están publicados:",
        "article-saved": "Artículo guardado",
        "article-published": "Artículo publicado",
        "article-unpublished": "Artículo despublicado",
        "article-deleted": "Artículo eliminado",
        "delete-article": "Eliminar artículo",
        "delete-article-prompt": "¿Eliminar «{{title}}»? Desaparecerá al instante del centro de ayuda y del asistente de soporte.",
        "load-failed": "No se pudo cargar el artículo.",
        "export": "Exportar",
        "import": "Importar",
        "export-failed": "No se pudieron exportar los artículos.",
        "import-title": "Importar artículos de ayuda",
        "import-checking": "Comprobando el archivo…",
        "import-preview": "{{file}} creará {{created}} y actualizará {{updated}} artículos, con {{images}} imágenes. Los artículos que no están en el archivo no cambian.",
        "import-invalid": "Este archivo no se puede importar:",
        "imported": "Importado: {{created}} creados, {{updated}} actualizados."
      },
      "invite-only": "Solo por invitación",
      "invite-only-hint": "Oculto en la página de planes. Cualquiera con el enlace puede suscribirse. No se puede cambiar después de crear el plan.",
      "invite-only-price-required": "Un plan solo por invitación necesita un precio mayor que 0",
      "copy-invite-link": "Copiar enlace de invitación",
      "invite-link-copied": "Enlace de invitación copiado",
      "invite-link-copy-failed": "No se pudo copiar el enlace de invitación"
    }
  },
  "search": {
    "no-result-found": "¡No se encontraron resultados!",
    "type": {
      "product": "Producto",
      "variant": "Variante",
      "client": "Cliente"
    },
    "show-less": "Mostrar menos",
    "show-full": "Mostrar completo",
    "search-x-by-full-name": "Buscar {{ x }} por nombre completo",
    "load-more...": "Cargar más..."
  },
  "privacy-policy": "Política de privacidad",
  "contact-us": "Contáctanos",
  "notification": {
    "notification": "Notificación",
    "mark-all-as-read": "Marcar todo como leído",
    "compose": "Redactar notificación",
    "title-required": "¡El título es obligatorio!",
    "message-required": "¡El mensaje es obligatorio!",
    "sent-to-all-clients": "Se ha enviado una notificación a todos los clientes"
  },
  "table": {
    "sort": "Ordenar",
    "sort-by": "Ordenar por",
    "oldest-first": "Más antiguos primero",
    "newest-first": "Más recientes primero",
    "a-z": "De la A a la Z",
    "z-a": "De la Z a la A",
    "lowest-first": "Menor primero",
    "highest-first": "Mayor primero",
    "no-data-found": "No se encontraron datos"
  },
  "grading": {
    "grading-configuration": "Configuración de graduación",
    "base-size": "Talla base",
    "enter-your-grading-allowances": "Introduce tus tolerancias de graduación",
    "base": "Base"
  },
  "chart": {
    "image-nav-previous": "Imagen anterior",
    "image-nav-next": "Imagen siguiente",
    "image-nav-position": "{{current}} / {{total}}",
    "image-add-slot-placeholder": "Añadir otra imagen",
    "image-add-slot-formats": "Admite .png, .jpeg, .jpg",
    "image-cap-reached": "Has alcanzado el número máximo de imágenes para esta categoría.",
    "image-upload-failed": "No se pudo subir la imagen. Inténtalo de nuevo.",
    "image-svg-not-accepted": "Aquí no se admiten archivos SVG.",
    "image-delete": "Eliminar imagen",
    "image-move-left": "Mover imagen a la izquierda",
    "image-move-right": "Mover imagen a la derecha",
    "image-delete-confirm-title": "¿Eliminar esta imagen?",
    "image-delete-confirm-body": "Esta imagen se eliminará de forma permanente y no se podrá recuperar.",
    "image-delete-confirm-cancel": "Cancelar",
    "image-delete-confirm-action": "Eliminar imagen",
    "image-delete-last-tooltip": "Una categoría debe conservar al menos una imagen.",
    "image-customize-first-tooltip": "Personaliza primero esta categoría para gestionar sus imágenes.",
    "image-delete-failed": "No se pudo eliminar la imagen. Inténtalo de nuevo.",
    "image-reorder-failed": "No se pudieron reordenar las imágenes. Inténtalo de nuevo.",
    "do-you-want-to-delete-this-chart": "¿Quieres eliminar esta tabla?",
    "unnamed-chart": "Tabla sin nombre",
    "get-size-chart-permalink": "Obtener enlace permanente de la tabla de tallas",
    "chart-external-link-is-copied-to-clipboard": "El enlace externo de la tabla se copió al portapapeles",
    "failed-to-duplicate-chart": "No se pudo duplicar la tabla",
    "failed-to-create-chart": "No se pudo crear la tabla",
    "add-new-layout-blocks": "Añadir nuevos bloques de diseño",
    "click-on-these-layout-types-and-add-to-the-size-chart": "Haz clic en estos tipos de diseño y añádelos a la tabla de tallas",
    "rename-chart": "Renombrar tabla",
    "chart-renamed-successfully": "Tabla renombrada correctamente",
    "failed-to-rename-chart": "No se pudo renombrar la tabla",
    "preview": "Vista previa",
    "model-info": "Información del modelo",
    "model-details": "Detalles del modelo",
    "help-shoppers-by-showing-the-model-height-and-size": "Ayuda a los compradores mostrando la altura y talla del modelo",
    "model-name": "Nombre del modelo",
    "enter-model-name": "Introduce el nombre del modelo",
    "model-height": "Altura del modelo",
    "please-enter-valid-number": "Introduce un número válido",
    "size-worn": "Talla usada",
    "show-variants-by": "Mostrar variantes por",
    "add-options-like-size-or-color": "Añade opciones como talla o color",
    "select-existing-chart": "Seleccionar tabla existente",
    "search-charts": "Buscar tablas por nombre",
    "no-charts-found": "No se encontraron tablas",
    "search-dimensions": "Buscar dimensiones",
    "no-dimensions-found": "No se encontraron dimensiones",
    "add-a-new-size-chart": "Añadir una nueva tabla de tallas",
    "this-product-is-using-table-chart": "Este producto está usando una tabla de cuadrícula",
    "update-your-size-chart": "Actualiza tu tabla de tallas",
    "create-your-size-chart": "Crea tu tabla de tallas",
    "use-a-template": "Usar una plantilla",
    "use-template-variants": "Usar plantilla y variantes",
    "pick-a-method-to-get-started": "Elige un método para empezar",
    "select-an-existing-chart": "Seleccionar una tabla existente",
    "image-set-annotation-panel": "Panel de anotación del conjunto de imágenes",
    "measure-guide": "Guía de medidas...",
    "drag-drop-to-mark-measurement-bubble": "Arrastra y suelta para marcar la burbuja de medida",
    "are-you-sure-you-want-to-delete-all-measurements": "¿Seguro que quieres eliminar todas las medidas?",
    "accepts-png-jpeg-jpg-svg": "Acepta .png, .jpeg, .jpg, .svg",
    "this-name-will-appear-in": "Este nombre aparecerá en",
    "image-set": "conjunto de imágenes",
    "added-measurements": "Medidas añadidas",
    "no-measurements-added-yet": "Aún no se han añadido medidas",
    "drag-and-drop-a-chip-to-edit-its-line-on-the-canvas": "Arrastra y suelta una ficha para editar su línea en el lienzo",
    "after-adding-a-measurement-drag-and-drop-it-from-the-section-above-onto-the-image": "Después de añadir una medida, arrástrala y suéltala desde la sección 'Medidas añadidas' de arriba sobre la imagen",
    "across-shoulder-front-rise-belt": "Ancho de hombros, tiro delantero, cinturón, ...",
    "create-measurement": "Crear medida",
    "examples-across-shoulder-front-rise-cuff-width": "Ejemplos: 'Ancho de hombros', 'Tiro delantero', 'Ancho de puño'",
    "delete-anotation-set": "Eliminar conjunto de anotaciones",
    "this-will-remove-all-measurements-from-this-image": "Esto eliminará todas las medidas de esta imagen",
    "measurement-name": "Nombre de la medida",
    "size-recommender": "Recomendador de talla",
    "size-recommender-history": "Recomendaciones recientes",
    "your-buyer-personal-fitting-assistant-that-instantly-suggests-the-perfect-size-every-time": "El asistente de ajuste personal de tu comprador que sugiere al instante la talla perfecta, cada vez",
    "stretch-factor": "Factor de elasticidad",
    "how-stretchy-is-the-fabric-a-rough-estimate-is-enough-if-unsure-then-leave-at-10": "¿Qué tan elástico es el tejido? Basta con una estimación aproximada. Si no estás seguro, déjalo en 10%",
    "easing": "Holgura",
    "wearing-ease-is-the-amount-added-to-a-person-body-measurements-so-one-can-move-in-a-garment": "La holgura de uso es la cantidad que se añade a las medidas corporales de una persona para poder moverse con la prenda.",
    "set-default": "Establecer como predeterminado",
    "suggested": "Sugerido",
    "assign-chart": "Asignar tabla",
    "your-chart-has-not-been-assigned-to-any-product-yet": "Tu tabla aún no se ha asignado a ningún producto",
    "assign-your-chart-so-it-will-appear-on-product-pages": "Asigna tu tabla para que aparezca en las páginas de producto",
    "assign-it-to-a-product": "Asignarla a un producto",
    "select-the-products-or-collections-where-you-want-your-size-chart-to-appear": "Selecciona los productos o colecciones donde quieres que aparezca tu tabla de tallas",
    "x-matched-y": "{{ x }} coincidió con {{ y }}",
    "overwritting-x-products": "(sobrescribiendo {{ x }} productos)",
    "calculating...": "Calculando...",
    "select-product-or-collection": "Seleccionar producto o colección",
    "remove-all": "Eliminar todo",
    "are-you-sure-you-want-to-remove-all-conditions": "¿Seguro que quieres eliminar todas las condiciones?",
    "list-of-matched-products": "Lista de productos coincidentes",
    "give-your-size-chart-a-name": "Dale un nombre a tu tabla de tallas",
    "this-name-is-only-used-internally-to-help-you-organise-your-charts-customers-wont-see-it": "Este nombre se usa solo internamente para ayudarte a organizar tus tablas. Los clientes no lo verán.",
    "eg-mens-t-shirt-size-chart": "p.ej. Tabla de tallas de camisetas de hombre",
    "add-text-block": "Añadir bloque de texto",
    "product-image-optional": "Imagen del producto (opcional)",
    "add-layout-block": "Añadir bloque de diseño",
    "move-this-block-up": "Mover este bloque hacia arriba",
    "move-this-block-down": "Mover este bloque hacia abajo",
    "clear-this-image": "Borrar esta imagen",
    "align-this-image": "Alinear esta imagen",
    "clear-this-video": "Borrar este video",
    "apply-grading-to-this-table": "Aplicar graduación a esta tabla",
    "duplicate-this-block-to-below": "Duplicar este bloque debajo",
    "remove-this-block": "Eliminar este bloque",
    "upload-an-image": "Subir una imagen",
    "browse-to-upload": "Explorar para subir",
    "choose-from-our": "Elige entre nuestras",
    "ready-made-templates": "plantillas prediseñadas",
    "select-a-template": "Seleccionar una plantilla",
    "new-row": "Nueva fila",
    "new-column": "Nueva columna",
    "add-column-left": "Añadir columna a la izquierda",
    "add-column-right": "Añadir columna a la derecha",
    "move-left": "Mover a la izquierda",
    "move-right": "Mover a la derecha",
    "freeze": "Fijar",
    "unfreeze": "Desfijar",
    "delete-column": "Eliminar columna",
    "add-row-above": "Añadir fila arriba",
    "add-row-below": "Añadir fila abajo",
    "move-up": "Mover arriba",
    "move-down": "Mover abajo",
    "delete-row": "Eliminar fila",
    "insert-video": "Insertar video",
    "select-a-video": "Seleccionar un video",
    "paste-a-link-to-a-video-here": "Pega aquí un enlace a un video",
    "webgl-not-supported": "Tu navegador no admite WebGL. Activa la compatibilidad con WebGL si usas un navegador moderno como Chrome, Firefox o Safari.",
    "table-chart-created": "Tabla de cuadrícula creada",
    "name-this-image-set": "Nombra este conjunto de imágenes",
    "name-your-import": "Nombra tu importación",
    "table-chart-updated": "Tabla de cuadrícula actualizada",
    "chart-updated": "Tabla actualizada",
    "use-how-to-measure-block": "¿Usar bloque de cómo medir? (Opcional)",
    "a-text-block-under-an-expandable-panel-will-be-added-where-you-can-fill-in-details-for-your-customers-on-how-to-measure-their-measurements": "Se añadirá un bloque de texto bajo un panel expandible donde podrás incluir detalles para tus clientes sobre cómo tomar sus medidas",
    "newest-5-recommendations-given-to-your-customers": "Las 5 recomendaciones más recientes dadas a tus clientes",
    "size-recommended": "Talla recomendada",
    "view-all-data": "Ver todos los datos",
    "please-select-a-size-worn": "Selecciona una talla usada",
    "recommended-for-this-garment-add-or-remove-as-needed": "Recomendado para esta prenda, añade o elimina según sea necesario",
    "add-more": "Añadir más",
    "add-custom-measurements": "Añadir medidas personalizadas",
    "skip-this-step-next-time": "Omitir este paso la próxima vez",
    "use-unit-conversion": "Usar conversión de unidades",
    "disabled-by-chart": "Deshabilitado por la tabla",
    "disabled-globally-by-settings": "Deshabilitado globalmente por la configuración",
    "hide-unit-conversion-toggle-on-all-charts-appear-on-your-storefront": "Ocultar el interruptor de conversión de unidades en todas las tablas que aparecen en tu tienda",
    "assign-products": "Asignar productos",
    "select-products-to-assign-to-the-chart": "Selecciona los productos a asignar a la tabla",
    "products-assigned-successfully": "Productos asignados correctamente",
    "source-table": "Tabla de origen",
    "root-table": "Tabla principal",
    "table-block": "Tabla",
    "which-axis-holds-the-dimension-data": "¿Qué eje contiene los datos de dimensión? (Hombro, cintura, etc.)",
    "columns": "Columnas",
    "rows": "Filas",
    "measurement-unit": "Unidad de medida",
    "map-each-line-to-a-dimension": "Asigna cada línea a una dimensión",
    "ignore": "Ignorar",
    "line": "Línea",
    "the-selected-table-has-no-data-to-map": "La tabla seleccionada no tiene datos para asignar.",
    "tell-us-how-your-table-maps-to-body-dimensions-so-we-can-suggest-a-size": "Cuéntanos cómo se relaciona tu tabla con las dimensiones corporales para poder sugerir una talla.",
    "choose-which-table-the-ai-reads-to-suggest-a-size": "Elige qué tabla lee la IA para sugerir una talla.",
    "per-dimension-stretch-and-easing-controls": "Controles de elasticidad y holgura por dimensión",
    "jump-to-table": "Ir a la tabla",
    "scroll-to-the-selected-table": "Desplázate a la tabla seleccionada",
    "this-table-is-used-as-your-size-recommendation-data-source": "Esta tabla se usa como fuente de datos para tu recomendación de talla",
    "this-table-block-can-not-be-deleted-right-now": "Este bloque de tabla no se puede eliminar en este momento"
  },
  "error": {
    "there-was-an-error-while-authenticating-your-store": "¡Hubo un error al autenticar tu tienda!",
    "click-the-button-below-to-try-again-if-the-issue-persisted-contact-us-for-further-instruction": "Haz clic en el botón de abajo para volver a intentarlo. Si el problema persiste, contáctanos para más instrucciones.",
    "refresh-the-app": "Actualizar la app",
    "error-occured": "¡Se produjo un error!"
  },
  "banner": {
    "add-the-goodchart-size-guide-button-to-your-storefront": "Añade el botón de guía de tallas de Goodchart a tu tienda",
    "we-ve-detected-you-are-integrating-with-shopify-enable-app-embed-or-add-an-app-block": "Hemos detectado que te estás integrando con Shopify. Habilita la app embed para mostrar automáticamente el botón de guía de tallas en cada página de producto, o añade un bloque de app para colocarlo en un lugar específico. ¿Necesitas ayuda? Consulta esta <a class=\"underline\" href=\"{{ guide }}\" target=\"_blank\">guía</a>.",
    "enable-app-embed": "Habilitar app embed",
    "add-app-block": "Añadir bloque de app",
    "your-new-size-chart-is-ready-to-review": "Tu nueva tabla de tallas está lista para revisar",
    "look-around-then-hand-the-conversion-over": "Nada ha cambiado para tus compradores todavía: tu tabla de cuadrícula sigue siendo la activa. Tómate tu tiempo para revisar las medidas y la guía, y luego completa la conversión cuando esté correcto.",
    "about-your-plan-usage": "Sobre el uso de tu plan",
    "measurements-applied": "Medidas aplicadas",
    "selection-applied-all-variants": "La selección se ha aplicado a todas las variantes de talla.",
    "you-have-reached-x-of-ai-size-recommendations-limit": "Has alcanzado el {{ x }}% del límite de recomendaciones de talla con IA de tu plan actual. Ten en cuenta que cualquier uso superior al 100% se cobrará a la tarifa estándar.",
    "you-have-reached-x-of-stock-notification-limit": "Has alcanzado el {{ x }}% del límite de notificaciones de stock de tu plan actual.",
    "over-usage-cost": "Coste de uso excedente",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-service": "Has superado tu límite de recomendaciones de talla con IA. Continúa pagando el coste de uso excedente para seguir usando el servicio.",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-this-feature": "Has superado tu límite de recomendaciones de talla con IA. Continúa pagando el coste de uso excedente para seguir usando esta función.",
    "n-of-your-table-charts-can-be-upgraded-to-smart-size-charts": "{{count}} de tus tablas de cuadrícula se pueden convertir en tablas de tallas inteligentes"
  },
  "onboarding": {
    "skip-for-now": "Omitir por ahora",
    "step-x-of-y": "Paso {{ x }} de {{ y }}",
    "select-the-category-that-best-matches-your-product": "Selecciona la categoría que mejor coincida con tu producto.",
    "apparel": "Ropa",
    "tops": "Partes de arriba",
    "pants": "Pantalones",
    "dresses": "Vestidos",
    "shoes": "Calzado",
    "sneakers": "Zapatillas",
    "boots": "Botas",
    "sandals": "Sandalias",
    "accessories": "Accesorios",
    "belts": "Cinturones",
    "bags": "Bolsos",
    "hats": "Sombreros",
    "other-custom": "Otro/Personalizado",
    "equipment": "Equipamiento",
    "tool": "Herramienta",
    "furniture": "Muebles",
    "upload-any-product-image-and-place-measurements-visually-works-for-apparel-shoes-and-accessories": "Sube cualquier imagen de producto y coloca las medidas visualmente. Funciona para ropa, calzado y accesorios.",
    "table-style-chart": "Tabla de estilo cuadrícula",
    "create-a-grid-based-chart-with-rows-and-columns-best-for-detailed-size-specifications": "Crea una tabla basada en cuadrícula con filas y columnas. Ideal para especificaciones de talla detalladas.",
    "your-size-chart-is-ready": "Tu tabla de tallas está lista",
    "you-can-now-decide-where-this-size-chart-should-appear-in-your-store-you-can-skip-this-step-and-assign-products-later": "Ahora puedes decidir dónde debe aparecer esta tabla de tallas en tu tienda. Puedes omitir este paso y asignar productos más tarde.",
    "apply-this-chart-to-products-now": "Aplicar esta tabla a productos ahora",
    "choose-which-products-should-use-this-size-chart": "Elige qué productos deben usar esta tabla de tallas.",
    "i-ll-do-this-later": "Lo haré más tarde",
    "you-can-assign-or-change-matching-anytime-from-chart-settings": "Puedes asignar o cambiar la coincidencia en cualquier momento desde la configuración de la tabla.",
    "select-products-to-assign-chart-to": "Selecciona los productos a los que asignar la tabla",
    "apply-this-chart-to-all-products": "Aplicar esta tabla a todos los productos.",
    "select-products-to-apply-this-chart-to": "Selecciona los productos a los que aplicar esta tabla.",
    "assigning...": "Asignando...",
    "size-chart-created-successfully": "Tabla de tallas creada correctamente",
    "you-can-assign-products-anytime-from-chart-settings": "Puedes asignar productos en cualquier momento desde la configuración de la tabla.",
    "view-chart": "Ver tabla",
    "go-to-dashboard": "Ir al panel",
    "turn-your-size-chart-into-a-conversion-tool": "Convierte tu tabla de tallas en una herramienta de conversión",
    "help-shoppers-pick-the-right-size-and-reduce-returns": "Ayuda a los compradores a elegir la talla correcta y reduce las devoluciones.",
    "setup-takes-about-2-minutes": "La configuración toma unos 2 minutos.",
    "choose-how-your-size-chart-looks": "Elige cómo se ve tu tabla de tallas",
    "other-ways-to-create-a-chart": "Otras formas de crear una tabla",
    "failed-to-proceed-please-try-again": "No se pudo continuar, inténtalo de nuevo",
    "this-chart-connects-to-your-shopify-product-and-variants-so-shoppers-can-select-their-size-add-to-cart-or-buy-now-without-leaving-the-chart": "Esta tabla se conecta a tu producto y variantes de Shopify, para que los compradores puedan seleccionar su talla, añadir al carrito o comprar ahora sin salir de la tabla",
    "add-the-size-guide-button-to-your-storefront": "Añade el botón de guía de tallas a tu tienda",
    "choose-how-the-goodchart-size-guide-button-should-appear-on-your-product-pages": "Elige cómo debe aparecer el botón de guía de tallas de GoodChart en tus páginas de producto.",
    "enable-app-embed": "Habilitar app embed",
    "installed": "Instalado",
    "automatically-display-the-size-guide-button-on-all-product-pages": "Muestra automáticamente el botón de guía de tallas en todas las páginas de producto.",
    "add-app-block-to-product-page": "Añadir bloque de app a la página de producto",
    "prefer-to-place-the-button-in-a-specific-spot-on-your-product-page": "¿Prefieres colocar el botón en un lugar específico de tu página de producto?",
    "place-the-size-guide-button-in-a-specific-spot-on-your-product-page-template": "Coloca el botón de guía de tallas en un lugar específico de la plantilla de tu página de producto.",
    "open": "Abrir",
    "check-button-installation": "Verificar instalación del botón",
    "checking": "Verificando...",
    "great-the-size-guide-button-is-installed-on-your-storefront": "¡Genial! El botón de guía de tallas está instalado en tu tienda.",
    "we-could-not-detect-the-size-guide-button-yet-please-make-sure-you-saved-the-changes-in-the-theme-editor": "Aún no pudimos detectar el botón de guía de tallas. Asegúrate de haber guardado los cambios en el editor de temas.",
    "app-block-installed-on-your-product-page": "Bloque de app instalado en tu página de producto"
  },
  "common": {
    "updated": "Actualizado",
    "name": "Nombre",
    "avatar": "Avatar",
    "category-image": "Imagen de categoría",
    "increase": "Aumentar",
    "created": "Creado",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "yes": "Sí",
    "no": "No",
    "chart": "Tabla",
    "gender": "Género",
    "height": "Altura",
    "weight": "Peso",
    "age-group": "Grupo de edad",
    "fit-preference": "Preferencia de ajuste",
    "score": "Puntuación",
    "table-chart": "Tabla de cuadrícula",
    "draft": "Borrador",
    "active": "Activo",
    "products": "Productos",
    "none": "Ninguno",
    "cancel": "Cancelar",
    "retry": "Reintentar",
    "delete": "Eliminar",
    "export": "Exportar",
    "variant": "Variante",
    "variants": "Variantes",
    "account": "Cuenta",
    "personal": "Personal",
    "appearance": "Apariencia",
    "organization": "Organización",
    "information": "Información",
    "first-name": "Nombre",
    "last-name": "Apellido",
    "save": "Guardar",
    "pay": "Pagar",
    "undo": "Deshacer",
    "redo": "Rehacer",
    "newsletter-subscription": "Suscripción al boletín",
    "button": "Botón",
    "colour": "Color",
    "default": "Predeterminado",
    "white": "Blanco",
    "light-grey": "Gris claro",
    "soft-beige": "Beige suave",
    "saving...": "Guardando...",
    "all-changes-saved": "Todos los cambios guardados",
    "publish": "Publicar",
    "unpublish": "Despublicar",
    "images": "Imágenes",
    "charts": "Tablas",
    "confirm": "Confirmar",
    "dimensions": "Dimensiones",
    "new": "Nuevo",
    "missing": "Faltante",
    "editing-x": "Editando {{ x }}",
    "back-in-stock": "De vuelta en stock",
    "product": "Producto",
    "grading": "Graduación",
    "more-actions": "Más acciones",
    "table": "Tabla",
    "measurement": "Medida",
    "close": "Cerrar",
    "apply": "Aplicar",
    "duplicate": "Duplicar",
    "add-layout-blocks": "Añadir bloques de diseño",
    "text": "Texto",
    "image": "Imagen",
    "video": "Video",
    "new-name": "Nuevo nombre",
    "published": "Publicado",
    "all": "Todo",
    "editing": "Editando",
    "show-more": "Mostrar más",
    "loading": "Cargando",
    "or": "O",
    "browse-files": "Explorar archivos",
    "edit": "Editar",
    "customize": "Personalizar",
    "clear": "Borrar",
    "label": "Etiqueta",
    "discard-changes": "Descartar cambios",
    "uploading": "Subiendo...",
    "preset": "Preestablecido",
    "custom": "Personalizado",
    "manage": "Gestionar",
    "done": "Hecho",
    "reminder": "Recordatorio",
    "collections": "Colecciones",
    "all-products": "Todos los productos",
    "select": "Seleccionar",
    "search": "Buscar",
    "select-all": "Seleccionar todo",
    "size-chart": "Tabla de tallas",
    "continue": "Continuar",
    "back": "Atrás",
    "visual-measurement-builder": "Constructor visual de medidas",
    "recommend": "Recomendar",
    "creating...": "Creando...",
    "syncing": "Sincronizando...",
    "preview": "Vista previa",
    "create": "Crear",
    "onboarding": "Incorporación",
    "english": "English",
    "french": "Français",
    "spanish": "Español",
    "czech": "Checo",
    "danish": "Danés",
    "german": "Alemán",
    "italian": "Italiano",
    "dutch": "Neerlandés",
    "japanese": "Japonés",
    "off": "Desactivado",
    "basic": "Básico",
    "AI": "IA",
    "details": "Detalles",
    "date": "Fecha",
    "billing": "Facturación",
    "settings": "Configuración",
    "log-out": "Cerrar sesión",
    "plan": "Plan",
    "ai-size-recommendation": "Recomendación de talla con IA",
    "recommendations": "Recomendaciones",
    "features": "Características",
    "stock-notification": "Notificación de stock",
    "published-size-charts": "Tablas de tallas publicadas",
    "published-table-charts": "Tablas de cuadrícula publicadas",
    "unlimited": "Ilimitado",
    "x-of-y": "{{ x }} de {{ y }}",
    "measurements": "Medidas",
    "selected": "Seleccionado",
    "select-product": "Seleccionar producto",
    "price": "Precio",
    "title": "Título",
    "message": "Mensaje",
    "add": "Añadir",
    "remove": "Eliminar",
    "cm": "cm",
    "in": "pulg",
    "usd": "USD",
    "return": "Volver",
    "next": "Siguiente",
    "store": "Tienda",
    "type": "Tipo",
    "cost": "Coste",
    "incurred-at": "Incurrido el",
    "search-placeholder": "Buscar...",
    "more": "Más...",
    "load-more": "Cargar más...",
    "status": "Estado",
    "enabled": "Habilitado",
    "disabled": "Deshabilitado",
    "total": "Total",
    "un-listed": "Sin listar",
    "global": "Global",
    "store-specific": "Específico de la tienda",
    "ai-measurement-import": "Importación de medidas con IA",
    "included": "Incluido",
    "not-included": "No incluido"
  },
  "snackbar": {
    "successfully-updated-your-preferences": "Tus preferencias se actualizaron correctamente",
    "failed-to-update-your-preferences": "No se pudieron actualizar tus preferencias"
  },
  "import": {
    "upload-file": "Subir archivo",
    "sheet-import": {
      "title": "Subir medidas desde un archivo",
      "dropzone": {
        "title": "Arrastra y suelta un archivo aquí",
        "accepted-types": "{{types}}: un archivo cada vez",
        "browse": "Buscar archivos"
      },
      "hint": "Para obtener mejores resultados: una sola tabla cuyas tallas coincidan con las variantes de esta tabla de tallas, con encabezados en la primera fila o columna. Si es una foto o captura de pantalla, que sea nítida, de frente y recortada a la tabla.",
      "example": {
        "caption": "Ejemplo de un diseño aceptado:",
        "size": "Talla",
        "chest": "Pecho (cm)",
        "waist": "Cintura (cm)"
      },
      "error": {
        "invalid-type": "Ese tipo de archivo no es compatible. Sube uno de estos: {{types}}.",
        "heic-unsupported": "Las fotos HEIC (el formato del iPhone) no son compatibles. Exporta la foto como JPG o PNG y sube ese archivo.",
        "file-too-large": "Ese archivo es demasiado grande. El tamaño máximo es de {{maxSizeMb}} MB."
      },
      "submit": "Subir y revisar los cambios",
      "running": {
        "this-chart": "Ya hay una importación en curso para esta tabla de tallas.",
        "other-chart": "Ya hay una importación en curso para otra tabla de tallas. Solo puede haber una importación a la vez.",
        "open-import": "Ver importación"
      },
      "accepted-files-tooltip": "Archivos admitidos: {{types}}",
      "button": {
        "importing": "Importando… {{progress}} %",
        "review": "Revisar importación"
      }
    }
  },
  "size-recommender": {
    "form": {
      "title": "Encuentra tu mejor talla",
      "subtitle": "Unos datos rápidos para un mejor ajuste",
      "shopping-for": "COMPRANDO PARA",
      "women": "Mujer",
      "men": "Hombre",
      "other": "Otro",
      "measurements": "MEDIDAS",
      "height": "Altura",
      "height-required": "La altura es obligatoria",
      "min-height": "La altura mínima es 1",
      "weight": "Peso",
      "weight-required": "El peso es obligatorio",
      "min-weight": "El peso mínimo es 1",
      "preferred-fit": "Ajuste preferido"
    },
    "result": {
      "suggested-size": "Talla sugerida:",
      "no-fit": "Lamentablemente, parece que no tenemos una talla ideal por el momento. Te recomendamos volver a consultar más tarde para ver más opciones.",
      "verdict": "Veredicto:",
      "similar-variants": "Variantes similares:",
      "proceed": "Continuar con esta variante",
      "estimate-disclaimer": "(Estimación basada en la marca y la información del usuario, los resultados pueden variar.)"
    },
    "ai": {
      "upgrade-title": "Mejora tu plan para desbloquear la recomendación de talla con IA",
      "upgrade-description": "Una función que ayuda a tus clientes a encontrar la talla correcta cada vez. Nuestra IA analiza los detalles del producto y la información del cliente para dar sugerencias de talla personalizadas, de modo que los compradores compren con confianza y tú veas menos devoluciones y cambios. Mejora tu plan ahora para ofrecer esta experiencia en tu tienda.",
      "image-alt": "Recomendación de talla",
      "upgrade-enable": "Mejorar y habilitar ahora",
      "explore-plans": "Explorar otros planes",
      "failed-load-recommendations": "No se pudieron cargar las recomendaciones",
      "failed-fetch-plans": "No se pudieron obtener los planes",
      "form-tab": "Formulario",
      "result-tab": "Resultado"
    },
    "basic": {
      "measurements-required-title": "Primero añade medidas",
      "measurements-required-description": "La recomendación de talla básica asigna una talla a los compradores según las medidas de esta tabla. Añade medidas a la tabla y luego actívala."
    }
  },
  "chart-limit": {
    "title-size": "Has alcanzado tu límite de tablas de tallas publicadas",
    "title-table": "Has alcanzado tu límite de tablas de cuadrícula publicadas",
    "description-size": "Tu plan te permite publicar {{limit}} tablas de tallas y tienes {{usage}} publicadas. Esta tabla se ha guardado como borrador. Mejora tu plan para publicar más o despublica una tabla que ya no necesites.",
    "description-table": "Tu plan te permite publicar {{limit}} tablas de cuadrícula y tienes {{usage}} publicadas. Esta tabla se ha guardado como borrador. Mejora tu plan para publicar más o despublica una tabla que ya no necesites.",
    "upgrade-plan": "Mejorar plan",
    "explore-plans": "Explorar planes",
    "failed-fetch-plans": "No se pudieron cargar los planes. Inténtalo de nuevo.",
    "image-alt": "Ilustración de tabla",
    "onboarding-saved-as-draft": "Tu tabla se guardó como borrador porque se alcanzó el límite de tablas publicadas de tu plan. Puedes publicarla después de mejorar tu plan o despublicar otra tabla."
  },
  "help-centre": "Centro de ayuda",
  "dimension-inputs": {
    "add-measurement": "Añadir medida"
  },
  "variant-editor": {
    "option-name": "Nombre de la opción",
    "option-values": "Valores de la opción",
    "option-placeholder": "Talla / Color / Tela",
    "add-option": "Añadir otra opción"
  },
  "dimension": {
    "shoulder": "Hombro",
    "bust": "Busto",
    "waist": "Cintura",
    "arm": "Brazo",
    "sleeve": "Manga",
    "hip": "Cadera",
    "crotch": "Entrepierna",
    "leg": "Pierna",
    "thigh": "Muslo",
    "length": "Largo",
    "bottom_width": "Ancho inferior",
    "chest": "Pecho",
    "inside_leg": "Entrepierna interior",
    "back_length": "Largo trasero",
    "front_length": "Largo delantero",
    "front_rise": "Tiro delantero",
    "back_rise": "Tiro trasero",
    "leg_opening": "Boca de pierna",
    "overbust": "Sobrebusto",
    "underbust": "Bajo busto",
    "groups": {
      "tops": "Partes de arriba",
      "bottoms": "Partes de abajo",
      "generals": "Generales"
    }
  },
  "analytic": {
    "range": {
      "1m": "1 mes",
      "3m": "3 meses",
      "6m": "6 meses",
      "1y": "1 año"
    }
  },
  "store-history": {
    "a-restore-is-already-running-for-this-store": "Ya hay una restauración en curso para esta tienda. Espera a que termine e inténtalo de nuevo.",
    "a-snapshot-is-taken-only-on-days-you-change-something": "Solo se crea una copia los días en que cambias algo.",
    "actor": {
      "merchant": "tú",
      "support": "Soporte de Goodchart",
      "system": "Shopify"
    },
    "billing-plan-login-and-connected-integrations-are-not-touched": "Tu facturación, plan, acceso e integraciones conectadas no se tocan.",
    "blocked": {
      "entity-exists": "Ya se recreó: restaura en su lugar",
      "entity-missing": "Ya no existe: restaura en su lugar",
      "unsupported": "No se puede deshacer: restaura en su lugar",
      "value-changed": "Cambió desde entonces: restaura en su lugar"
    },
    "changes": "Cambios",
    "discard-unsaved-changes": "¿Descartar los cambios sin guardar?",
    "dont-ask-again-in-this-session": "No volver a preguntar en esta sesión",
    "earlier": "Antes",
    "history": "Historial",
    "history-starts-from-your-first-snapshot": "El historial empieza en tu primera copia",
    "label": {
      "category-created": "Categoría {{name}} creada",
      "category-deleted": "Categoría {{name}} eliminada",
      "category-updated": "Categoría {{name}} editada",
      "chart-created": "Guía {{name}} creada",
      "chart-deleted": "Guía {{name}} eliminada",
      "chart-updated": "Guía {{name}} editada",
      "dimension-created": "Medida {{name}} creada",
      "dimension-deleted": "Medida {{name}} eliminada",
      "dimension-updated": "Medida {{name}} editada",
      "draft-assignment-rules": "Reglas de asignación cambiadas",
      "draft-edited": "Tabla editada",
      "draft-guide": "Guía de medición editada",
      "draft-labels": "Etiquetas de talla editadas",
      "draft-measurements": "Medidas editadas",
      "draft-model": "Medidas del modelo cambiadas",
      "draft-publication": "Publicación cambiada",
      "draft-renamed": "Tabla renombrada",
      "draft-size-recommender": "Recomendador de tallas cambiado",
      "draft-variants": "Variantes editadas",
      "keyword-created": "Palabra clave {{name}} creada",
      "keyword-deleted": "Palabra clave {{name}} eliminada",
      "keyword-updated": "{{count}} palabras clave editadas",
      "products-assigned": "{{count}} productos asignados",
      "profile-updated": "Perfil de la tienda actualizado",
      "store-restored": "Tienda restaurada al {{date}}",
      "table-chart-created": "Tabla {{name}} creada",
      "table-chart-deleted": "Tabla {{name}} eliminada",
      "table-chart-updated": "Tabla {{name}} editada"
    },
    "no-changes-since-then": "Sin cambios desde entonces.",
    "no-snapshots-yet": "Aún no hay copias",
    "nothing-created-since-then-will-be-deleted": "No se eliminará nada creado desde entonces.",
    "plus-x-more": "+{{x}} más",
    "reloading-the-dashboard": "Recargando el panel…",
    "restore": "Restaurar",
    "restore-confirmation-word": "RESTAURAR",
    "restore-instead": "Restaurar en su lugar",
    "restore-your-store": "Restaurar tu tienda",
    "restoring-your-store-do-not-close-this-window": "Restaurando tu tienda. No cierres esta ventana.",
    "since-the-x-snapshot": "Desde la copia del {{x}}",
    "snapshots": "Copias",
    "the-change-was-undone-but-the-page-could-not-refresh": "El cambio se deshizo, pero esta página no pudo actualizarse. Recarga para verlo.",
    "this-backup-predates-image-protection": "Esta copia es anterior a la protección de imágenes, así que cualquier imagen eliminada desde entonces no se puede recuperar.",
    "this-changes-what-shoppers-see-on-your-product-pages-within-seconds": "Esto cambia en segundos lo que ven los compradores en tus páginas de producto.",
    "this-changes-what-shoppers-see-right-away": "Esto cambia de inmediato lo que ven los compradores.",
    "this-puts-your-store-back-to-how-it-was-on-x": "Esto devuelve tu tienda al estado del {{x}}.",
    "this-reverses-x-actions-up-to-and-including-y": "Esto deshace {{x}} acciones, hasta «{{y}}» incluida.",
    "trigger": {
      "daily": "Diaria",
      "install": "Al instalar Goodchart",
      "manual": "Manual (soporte)",
      "migration": "Primera copia",
      "pre-restore": "Antes de restaurar",
      "reinstall": "Al reinstalar Goodchart"
    },
    "type-x-to-confirm": "Escribe {{x}} para confirmar",
    "undid-x": "Se deshizo «{{x}}»",
    "undo-a-saved-change": "Deshacer un cambio guardado",
    "undo-to-here": "Deshacer hasta aquí",
    "undo-x-saved-y": "¿Deshacer «{{x}}», guardado {{y}}?",
    "unsaved": "Sin guardar",
    "we-could-not-load-your-history": "No pudimos cargar tu historial.",
    "we-could-not-load-your-snapshots": "No pudimos cargar tus copias.",
    "we-could-not-restore-your-store": "No pudimos restaurar tu tienda.",
    "we-could-not-work-out-what-would-change": "No pudimos calcular qué cambiaría.",
    "we-take-a-snapshot-of-your-current-store-first-so-this-can-be-undone": "Primero hacemos una copia de tu tienda actual, para que esto se pueda deshacer.",
    "we-take-a-snapshot-of-your-store-each-day-it-changes": "Hacemos una copia de tu tienda cada día que cambia. Tu historial aparecerá aquí en cuanto se cree la primera.",
    "what-comes-back": "Lo que vuelve",
    "what-is-lost": "Lo que se pierde",
    "working-out-what-would-change": "Calculando qué cambiaría…",
    "x-assignments": "{{x}} asignaciones",
    "x-charts": "{{x}} guías",
    "x-images-cannot-be-brought-back": "No se pueden recuperar {{x}} imágenes: se eliminaron hace más de 37 días.",
    "x-images-could-not-be-recovered": "No se pudieron recuperar {{x}} imágenes: se eliminaron hace más de 37 días.",
    "x-items-created-since-then-will-be-deleted": "Se eliminarán {{x}} elementos creados desde entonces, entre ellos:",
    "x-items-will-be-recreated": "Se recrearán {{x}} elementos.",
    "x-no-longer-exists-after-the-undo": "«{{x}}» ya no existe después de deshacer.",
    "x-table-charts": "{{x}} tablas",
    "you-have-unsaved-changes-to-x-undoing-will-discard-them": "Tienes cambios sin guardar en «{{x}}». Deshacer los descartará.",
    "your-store-has-been-restored": "Tu tienda se ha restaurado."
  },
  "chart-import": {
    "progress": {
      "stage": {
        "reading-file": "Leyendo tu archivo",
        "understanding-table": "Analizando la tabla",
        "matching-measurements": "Asociando las medidas",
        "building-chart": "Creando tu tabla de tallas"
      },
      "reconnecting": "Reconectando: espera un momento, tu progreso no se ha perdido.",
      "keep-working": "Puedes seguir trabajando: te avisaremos cuando esté listo.",
      "cancel": "Cancelar importación",
      "cancel-confirm": {
        "title": "¿Cancelar esta importación?",
        "message": "Se descartará el archivo que subiste y esta importación no se podrá reanudar.",
        "keep": "Seguir esperando",
        "discard": "Cancelar importación"
      },
      "ready": {
        "title": "Tabla de tallas lista para revisar",
        "action": "Revisar los cambios"
      }
    },
    "failure": {
      "unreadable-file": {
        "message": "La foto estaba demasiado borrosa u oscura para poder leerla. Una foto más nítida y bien iluminada funciona mejor."
      },
      "no-table-found": {
        "message": "No encontramos ninguna tabla de tallas en este archivo."
      },
      "unsupported-layout": {
        "message": "Todavía no podemos leer el diseño de esta tabla."
      },
      "model-timeout": {
        "message": "Ha tardado demasiado; normalmente es un fallo temporal."
      },
      "internal": {
        "message": "Algo salió mal por nuestra parte al importar tu tabla de tallas."
      },
      "action": {
        "retry": "Reintentar",
        "try-another-photo": "Probar con otra foto",
        "try-another-file": "Probar con otro archivo",
        "other-methods": "Otros métodos"
      }
    },
    "diff-review": {
      "title": "Revisa los cambios",
      "subtitle": "Desmarca lo que no quieras aplicar a esta tabla de tallas.",
      "load-error": "No pudimos cargar los cambios de esta importación.",
      "no-changes": "No ha cambiado ninguna medida.",
      "grid": {
        "variant": "Talla",
        "dimension": "Medida",
        "old-value": "Actual",
        "new-value": "Nuevo"
      },
      "unmatched-variants": "Tallas del archivo que no coinciden con esta tabla de tallas:",
      "unmapped-dimensions": "Columnas que no pudimos asociar a una medida:",
      "apply": {
        "button": "Aplicar cambios ({{count}})",
        "success": "Tabla de tallas actualizada ({{count}} cambios aplicados)",
        "generic-error": "No pudimos aplicar estos cambios. Inténtalo de nuevo."
      },
      "cancel": {
        "button": "Cancelar importación"
      }
    },
    "review": {
      "cancel-confirm": {
        "title": "¿Cancelar esta importación?",
        "message": "Se descartarán el archivo que subiste y los cambios de la revisión. Esta importación no se podrá reanudar.",
        "keep": "Seguir revisando",
        "discard": "Cancelar importación"
      }
    },
    "page": {
      "title": "Importar medidas",
      "empty": {
        "title": "No hay ninguna importación en curso para esta tabla de tallas",
        "message": "Sube una hoja de cálculo o una foto de una tabla de tallas para actualizar las medidas de esta tabla."
      }
    },
    "upgrade": {
      "title": "Importa medidas con IA",
      "description": "Sube una hoja de cálculo o una foto de una tabla de tallas y completaremos las medidas de esta tabla por ti. La importación de medidas con IA no está incluida en tu plan actual. Mejora tu plan para usarla.",
      "upgrade-plan": "Mejorar plan",
      "explore-plans": "Explorar planes",
      "failed-fetch-plans": "No se pudieron cargar los planes. Inténtalo de nuevo.",
      "image-alt": "Ilustración de una tabla de tallas"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday",
      "chip": "Precio de Black Friday",
      "popup": {
        "eyebrow": "Black Friday · Cyber Monday",
        "headline": "Hasta un {{percent}} % de descuento",
        "subheadline": "en los planes de Goodchart",
        "body": "Prepara tus guías de tallas para la semana con más ventas del año. Tallas claras significan menos preguntas de \"¿me quedará bien?\" y menos devoluciones.",
        "feature-recommender": "Recomendador de tallas con IA que sugiere la talla de cada cliente",
        "feature-import": "Importación con IA que convierte un archivo o una imagen en una guía de tallas",
        "feature-analytics": "Analíticas sobre cómo usan los clientes tus guías de tallas",
        "cta": "Ver las ofertas",
        "later": "Quizás más tarde"
      },
      "show-offer": "Ver la oferta de Black Friday"
    },
    "every-plan": "{{percent}} % de descuento en todos los planes",
    "up-to": "Hasta un {{percent}} % de descuento",
    "switch-to": "Cambiar a {{price}} $/{{interval}}",
    "switch-from": "Tienes {{name}} por {{price}} $/{{interval}}. Mismas funciones, un {{percent}} % menos.",
    "switch-note-monthly": "Shopify te pide aprobar el nuevo precio y te abona el resto de este mes.",
    "switch-note-annual": "Shopify te pide aprobar el nuevo precio, que empieza con tu renovación el {{date}}.",
    "switch-note-annual-undated": "Shopify te pide aprobar el nuevo precio, que empieza con tu próxima renovación."
  },
  "agent-chat": {
    "open": "Abrir el chat de soporte",
    "close": "Cerrar el chat de soporte",
    "expand": "Ampliar el chat",
    "collapse": "Reducir el chat",
    "title": "Soporte de Goodchart",
    "history": "Conversaciones",
    "back": "Volver a la conversación",
    "new": "Nueva conversación",
    "placeholder": "Haz una pregunta sobre Goodchart",
    "send": "Enviar",
    "welcome": "¡Hola! Pregúntame lo que quieras sobre Goodchart: crear tablas de tallas, la guía de tallas en tu tienda o tu plan.",
    "history-empty": "Aún no hay conversaciones.",
    "unread": "Nueva respuesta",
    "you": "Tú",
    "merchant": "Comerciante",
    "assistant": "Asistente de Goodchart",
    "team": "Equipo de Goodchart",
    "typing": "Escribiendo…",
    "used-articles": "Respondido con los artículos de ayuda",
    "retry": "Intentar de nuevo",
    "activity": {
      "articles": "Leyendo los artículos de ayuda…",
      "store": "Revisando tu tienda…",
      "code": "Comprobando cómo funciona Goodchart…",
      "team": "Pasando esto al equipo de Goodchart…"
    },
    "error": {
      "rate-limited": "Estás enviando mensajes muy rápido. Inténtalo de nuevo en {{seconds}} segundos. Si necesitas al equipo de Goodchart, pídemelo cuando puedas volver a escribir.",
      "daily-cap": "Has alcanzado el límite de mensajes de hoy. Inténtalo de nuevo mañana y pídeme entonces al equipo de Goodchart si aún lo necesitas.",
      "disabled": "El asistente de soporte no está disponible en este momento.",
      "reply-failed": "La respuesta no llegó.",
      "unknown": "Algo salió mal."
    },
    "placeholder-team": "Añade detalles para el equipo de Goodchart",
    "unavailable": "El asistente de soporte no está disponible en este momento, así que no acepta preguntas nuevas. Las conversaciones que ya tiene el equipo de Goodchart siguen abiertas en tu historial.",
    "waiting": {
      "title": "Esperando al equipo de Goodchart.",
      "body": "Responderán aquí y recibirás una notificación. Mientras tanto, puedes añadir detalles."
    },
    "starters": {
      "create-chart": "¿Cómo creo una tabla de tallas?",
      "no-chart": "¿Qué productos no tienen tabla de tallas?",
      "not-showing": "¿Por qué no aparece mi tabla de tallas en mi tienda?",
      "charts-left": "¿Cuántas tablas más puedo publicar?"
    },
    "feedback": {
      "helpful": "Útil",
      "not-helpful": "No útil",
      "thanks": "Gracias por tu opinión.",
      "comment-placeholder": "¿Qué estaba mal o faltaba? (opcional)",
      "send": "Enviar",
      "skip": "Omitir",
      "rated-up": "Valorado como útil",
      "rated-down": "Valorado como no útil"
    }
  }
}
